<template>
  <div>
    <van-swipe indicator-color="#FD2840" :duration="duration" :style="'margin-top:-2.6rem'">
      <van-swipe-item v-for="(item, index) in content" :key="index">
        <!-- <router-link :to="'/'+item.url.name+'?id='+item.url.query.id"> -->
        <img :src="item.pic_url" alt @click="onRbLink(item)" />
        <!-- </router-link> -->
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from "vant";

export default {
  name: "SlidePics",
  components: {
    Swipe,
    SwipeItem
  },
  props: {
    content: {
      type: Array,
      default: []
    },

    top: {
      type: String,
      default: ""
    }
  },

  data: function() {
    return {
      duration: 300
    };
  },

  methods: {
    onRbLink(item) {
       
      rbLink({
        name: item.url.name.substring(0, 1).toUpperCase() + item.url.name.substring(1),
        query: item.url.query
      });
    }
  },

  filters: {}
};
</script>

<style scoped>
.van-swipe-item {
  display: flex;
  justify-content: center;
}
.van-swipe-item img {
  width: 7.1rem;
  border-radius: 0.2rem;
}
</style>


// WEBPACK FOOTER //
// SlidePics.vue?2f48aafc